import { Vector3 } from "three";
import EditorCell from "./EditorCell.tsx";
import EditorTile from "./EditorTile.tsx";
import {
  EditorState,
  setSelectedPrototypeToMapAt,
  useEditorStore,
} from "./stores/editorStore.ts";
import { useEffect } from "react";
import EditorPrototype from "./EditorPrototype.tsx";

interface WorldProps {
  cellSize: number;
}

export default function EditorWorld({ cellSize }: WorldProps): JSX.Element {
  const { map, setMap, selectedPrototype, setSelectedPrototype } =
    useEditorStore();

  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === "r" || event.key === "R") {
      if (selectedPrototype) {
        const rotatedSelectedPrototype = selectedPrototype;
        rotatedSelectedPrototype.mesh_rotation =
          (rotatedSelectedPrototype.mesh_rotation + 1) % 4;
        setSelectedPrototype(rotatedSelectedPrototype);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [selectedPrototype]);

  const gridMapCoordinatesTo3DWorldCoordinates = (
    x: number,
    y: number,
    z: number,
  ): Vector3 => {
    const offset = cellSize / 2; // TODO : fix this, this is to center the pieces to its corner on 0,0
    return new Vector3(
      x * cellSize - offset,
      y * cellSize + offset,
      z * cellSize - offset,
    );
  };

  return (
    <>
      {map.map((x, xIndex) => {
        return x.map((y, yIndex) => {
          return y.map((z, zIndex) => {
            const cell = z;
            const coordinates = gridMapCoordinatesTo3DWorldCoordinates(
              xIndex,
              yIndex,
              zIndex,
            );

            return (
              <EditorTile
                key={`${xIndex}-${yIndex}-${zIndex}`}
                tilePosition={coordinates}
                gridPosition={new Vector3(xIndex, yIndex, zIndex)}
                tileSize={cellSize}
                prototype={cell.prototype}
                editable={cell.editable}
                onEditableTileLeftClick={(position: Vector3) => {
                  if (selectedPrototype) {
                    setMap(
                      setSelectedPrototypeToMapAt(map, position, {
                        ...selectedPrototype,
                      } as EditorPrototype),
                    );
                  }
                }}
                onEditableTileRightClick={function (position: Vector3): void {
                  setMap(setSelectedPrototypeToMapAt(map, position, null));
                }}
              />
            );
          });
        });
      })}
    </>
  );
}
